<template>
  <DashboardLayout>

    <div class="d-flex align-items-center gap-2 mb-4 page-identifier">
      <router-link :to="{ name: 'ViewBanks' }" class="mb-0 main-identifier fw-semibold text-decoration-none"
        title="Go back to Banks">
        Banks
      </router-link>
      <span class="material-symbols-outlined">keyboard_arrow_right</span>
      <p class="mb-0 sub-identifier">View Bank</p>
    </div>

    <div class="d-flex justify-content-center">
      <div class="form-outer">
        <div class="crud-form position-relative">

          <div class="form-inner">
            <div class="form-header d-flex justify-content-between align-items-center">
              <h1 class="mb-0">Bank</h1>
            </div>

            <div class="form-body">
              <div v-if="loading" class="text-center py-5">
                <div class="spinner-border text-primary" role="status" aria-hidden="true"></div>
                <p class="mt-2 mb-0 text-muted">Loading bank details...</p>
              </div>

              <div v-else>
                <div class="row mt-2 mb-3">

                  <div class="col-md-12 row form-group position-relative floating-label-group">
                    <div class="col-md-3 label-left d-flex justify-content-end align-items-center">
                      <label class="form-label fw-bold fixed-label">Bank Name:</label>
                    </div>
                    <div class="col-md-9 form-row-input">
                      <input type="text" class="form-control form-view-only-input" :value="bank.bankName" readonly>
                    </div>
                  </div>

                  <div class="col-md-12 row form-group position-relative floating-label-group">
                    <div class="col-md-3 label-left d-flex justify-content-end align-items-center">
                      <label class="form-label fw-bold fixed-label">Bank Code:</label>
                    </div>
                    <div class="col-md-9 input-right">
                      <input type="text" class="form-control form-view-only-input" :value="bank.bankCodeName" readonly>
                    </div>
                  </div>

                  <div class="col-md-12 row form-group position-relative floating-label-group">
                    <div class="col-md-3 label-left d-flex justify-content-end align-items-center">
                      <label class="form-label fw-bold fixed-label">Sort Code:</label>
                    </div>
                    <div class="col-md-9 input-right">
                      <input type="text" class="form-control form-view-only-input" :value="bank.bankSortCode" readonly>
                    </div>
                  </div>

                </div>

                <div class="d-flex justify-content-center">
                  <button type="button" class="btn btn-primary submit-btn">
                    <router-link :to="{ name: 'EditBank', params: { id: id } }"
                      class="text-decoration-none" style="color: #fff">
                      Edit Bank
                    </router-link>
                  </button>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>

  </DashboardLayout>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { useRoute } from 'vue-router'
import axios from 'axios'
import Cookies from 'js-cookie'
import DashboardLayout from '../layout/DashboardLayout.vue'
import Swal from 'sweetalert2'

const root_api_url = process.env.VUE_APP_API_ROOT_URL
const route = useRoute()
const id = route.params.id

const loading = ref(true)
const bank = ref({
  bankName: '',
  bankCodeName: '',
  bankSortCode: '',
})

const fetchBank = async () => {
  const token = Cookies.get('auth_token')
  loading.value = true
  try {
    const response = await axios.get(`${root_api_url}/payment/banks/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    })
    const data = response.data
    bank.value.bankName = data.bankName ?? ''
    bank.value.bankCodeName = data.bankCodeName ?? ''
    bank.value.bankSortCode = data.bankSortCode ?? ''
  } catch (error) {
    console.error('Failed to fetch bank:', error)
    const iconHtmlError = `<span class="iconify" data-icon="material-symbols:cancel-outline-rounded" style="font-size: 100px; color: red;"></span>`
    Swal.fire({
      html: `${iconHtmlError}<h1 style="font-weight:600;">Error</h1><p>Failed to load bank details.</p>`,
      showConfirmButton: true,
      showCloseButton: true,
      icon: undefined,
    })
  } finally {
    loading.value = false
  }
}

onMounted(async () => {
  await fetchBank()
  document.title = 'View Bank'
})
</script>

<style scoped>
.form-header h1 {
  font-size: 1.5rem;
  color: #333;
}

.crud-form {
  background: white;
  border: 1px solid #d8d8d8;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

/* Form Container */
.form-outer {
  width: 100%;
  max-width: 800px;
  /* padding: 1rem; */
}

.form-view-only-input {
  background: white;
  border: 1px solid #d8d8d8 !important;
  border-radius: 8px;
  padding: 0.5rem 0.75rem;
  outline: none;
  box-shadow: none !important;
  cursor: default;
}

.submit-btn {
  background-color: #3498db !important;
  border-color: #3498db !important;
}

.submit-btn:hover {
  background-color: #2980b9 !important;
  border-color: #2980b9 !important;
}
</style>
